enum GatewayNames {
  API_CLIENT = 'API_CLIENT',
  TRANSACTION_CLIENT = 'TRANSACTION_CLIENT',
  FOLDER_CLIENT = 'FOLDER_CLIENT',
  RULE_CLIENT = 'RULE_CLIENT',
  USER_CLIENT = 'USER_CLIENT',
  GROUP_CLIENT = 'GROUP_CLIENT',
  ROLE_CLIENT = 'ROLE_CLIENT',
  AUDIT_CLIENT = 'AUDIT_CLIENT',
  LIST_CLIENT = 'LIST_CLIENT',
  LIST_DATA_CLIENT = 'LIST_DATA_CLIENT',
  ENRICHMENT_CLIENT = 'ENRICHMENT_CLIENT',
  CONNECTION_CLIENT = 'CONNECTION_CLIENT',
  CASE_CLIENT = 'CASE_CLIENT',
  ENTITY_CLIENT = 'ENTITY_CLIENT',
  DOMAIN_CONFIGURATION_CLIENT = 'DOMAIN-CONFIGURATION_CLIENT',
  STRUCT_CLIENT = 'STRUCT_CLIENT',
  SANDBOX_CLIENT = 'SANDBOX_CLIENT',
  STREAM_CLIENT = 'STREAM_CLIENT',
  ACTION_CLIENT = 'ACTION_CLIENT',
  JOB_CLIENT = 'JOB_CLIENT',
  MAKER_CHECKER_CLIENT = 'MAKER_CHECKER_CLIENT',
  NOTIFICATION_CLIENT = 'NOTIFICATION_CLIENT',
  WATCHLIST_CLIENT = 'WATCHLIST_CLIENT',
  CUSTOM_LIST_CLIENT = 'CUSTOM_LIST_CLIENT',
  CHART_CLIENT = 'CHART_CLIENT',
  DASHBOARD_CLIENT = 'DASHBOARD_CLIENT',
  AI_CLIENT = 'AI_CLIENT',
  TRACKER_CLIENT = 'TRACKER_CLIENT',
  CRA_CLIENT = 'CRA_CLIENT',
  ACH_CLIENT = 'ACH_CLIENT'
}

export default GatewayNames;
